// src/pages/warehouses/index.js
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Typography } from "antd";
import { fetchWarehousesList } from "./warehousesThunks";
import WarehouseList from "./components/WarehouseList";

const { Title } = Typography;

const Warehouses = () => {
  const dispatch = useDispatch();
  const { warehouses } = useSelector((state) => state.warehouses);

  useEffect(() => {
    dispatch(fetchWarehousesList());
  }, [dispatch]);

  return (
    <>
      <Title level={2}>Warehouse</Title>
      <WarehouseList warehouses={warehouses} />
    </>
  );
};

export default Warehouses;
